module.exports = __webpack_public_path__ + "img/ia.7a1452ef.svg";